// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function optIncludes(src, v) {
  return Stdlib_Option.getOr(src, []).includes(v);
}

function toggleIncluded(src, v) {
  let arr = Stdlib_Option.getOr(src, []).slice();
  if (arr.includes(v)) {
    let newArr = arr.filter(c => c !== v);
    if (newArr.length !== 0) {
      return newArr;
    } else {
      return;
    }
  }
  arr.push(v);
  return arr;
}

exports.optIncludes = optIncludes;
exports.toggleIncluded = toggleIncluded;
/* No side effect */
